/* istanbul ignore file */
export default class ServerError extends Error {
    public code: string;
    constructor(code: string) {
        super(code);

        this.code = code;
        Object.setPrototypeOf(this, ServerError.prototype);
    }
}
